import type { AxiosError } from "axios";

/**
 * A user without a branch has access to all branches. The API stores and
 * returns that as null; "None" and "null" are what older records carry.
 */
export const isAllBranches = (branchId: string | null | undefined): boolean =>
  branchId == null ||
  ["", "none", "null"].includes(branchId.trim().toLowerCase());

/** Radix Select items cannot have an empty value, so "All branches" needs its own. */
export const ALL_BRANCHES_VALUE = "__all_branches__";

export const toBranchSelectValue = (branchId: string | null | undefined) =>
  isAllBranches(branchId) ? ALL_BRANCHES_VALUE : (branchId as string);

export const fromBranchSelectValue = (value: string): string | null =>
  value === ALL_BRANCHES_VALUE ? null : value;

/** "<what failed>: <reason from the API>", or just what failed when the API gave no reason. */
export const describeApiError = (error: unknown, whatFailed: string): string => {
  const reason = (error as AxiosError<{ error?: unknown }>)?.response?.data
    ?.error;
  return typeof reason === "string" && reason
    ? `${whatFailed}: ${reason}`
    : whatFailed;
};
